import { render } from "./ReceivedEmailListing.vue?vue&type=template&id=742a4c27&scoped=true"
import script from "./ReceivedEmailListing.vue?vue&type=script&lang=js"
export * from "./ReceivedEmailListing.vue?vue&type=script&lang=js"

import "./ReceivedEmailListing.vue?vue&type=style&index=0&id=742a4c27&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742a4c27"]])

export default __exports__